import { DsStack, DsTypography } from '@am92/react-design-system'
import React from 'react'
import ProfileCard from './ProfileCard'

export type Account = {
  settlementType: number
  subAccountId: string
  isPrimary: boolean
  name: string
  accountType: string
}

interface NroProps {
  accounts: Account[]
  selectedAccount: Account
  handleOnSelectAccount: (item: number) => Promise<any>
}

interface NroState { }

class Nro extends React.Component<NroProps, NroState> {
  handleGetCardType = (accountType: number) => {
    const { accounts, selectedAccount } = this.props

    const accountPresent = accounts.find(
      (account: { settlementType: number }) =>
        account?.settlementType === accountType
    )

    if (accountPresent) {
      if (selectedAccount.settlementType === accountType) {
        return 'active'
      }
      return 'primary'
    }
    if (!accountPresent) {
      return 'disabled'
    }
    return 'disabled'
  }

  render() {
    const { accounts, handleOnSelectAccount } = this.props
    return (
      <DsStack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--ds-spacing-bitterCold)',
          alignItems: 'center'
        }}
      >
        <DsTypography variant='bodyBoldMedium'>
          NRO - Non-Resident Ordinary Account
        </DsTypography>
        <DsStack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 'var(--ds-spacing-bitterCold)'
          }}
        >
          <ProfileCard
            onClick={() => handleOnSelectAccount(1)}
            type={this.handleGetCardType(1)}
            heading='NRO PIS'
            description='For investing in Equity'
          />
          <ProfileCard
            onClick={() => handleOnSelectAccount(2)}
            type={this.handleGetCardType(2)}
            heading='NRO NON'
            description='For investing in IPO, ETF, MFs, Bonds, ESOPs, Derivatives'
          />
        </DsStack>
      </DsStack>
    )
  }
}

export default Nro
